import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
}

export default function Blog() {
  const { t } = useLang();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((res) => {
      setPosts(res.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-mtk-bg text-white flex flex-col">
      <Navbar />

      <main className="flex-1 max-w-5xl mx-auto w-full px-6 md:px-10 pt-32 pb-20">
        <div className="mb-12">
          <span className="font-mono-mtk text-[10px] tracking-[0.4em] uppercase text-mtk-gold">
            MTK SYSTEM
          </span>
          <h1 className="font-heading text-4xl md:text-5xl font-black uppercase tracking-tight text-white mt-2">
            {t.blog.title}
          </h1>
        </div>

        {loading && (
          <div className="font-mono-mtk text-[10px] tracking-[0.3em] text-zinc-600 uppercase">
            LOADING…
          </div>
        )}

        {!loading && posts.length === 0 && (
          <p className="font-mono-mtk text-xs tracking-[0.3em] uppercase text-zinc-500">
            {t.blog.noPosts}
          </p>
        )}

        {!loading && posts.length > 0 && (
          <div className="flex flex-col gap-px bg-mtk-border border border-mtk-border">
            {posts.map((post) => (
              <article
                key={post.id}
                className="bg-mtk-bg hover:bg-mtk-surface transition-colors group"
              >
                <Link to={`/blog/${post.slug}`} className="block px-8 py-8 md:py-10">
                  <div className="flex items-start justify-between gap-6">
                    <div className="flex-1 min-w-0">
                      <span className="font-mono-mtk text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                        {formatDate(post.created_at)} · {post.author}
                      </span>
                      <h2 className="font-heading text-xl md:text-2xl font-black uppercase tracking-tight text-white mt-2 group-hover:text-mtk-gold transition-colors">
                        {post.title}
                      </h2>
                      {post.excerpt && (
                        <p className="mt-3 text-zinc-400 text-sm leading-relaxed line-clamp-2">
                          {post.excerpt}
                        </p>
                      )}
                    </div>
                    <span className="font-mono-mtk text-[10px] tracking-[0.3em] uppercase text-mtk-gold group-hover:translate-x-1 transition-transform shrink-0 pt-1">
                      →
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
